import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28b3905e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center fw-bolder text-uppercase mb-0" }
const _hoisted_2 = {
  class: "text-center mb-1 fst-italic",
  style: {"font-size":"0.8rem"}
}
const _hoisted_3 = {
  key: 0,
  class: "text-center mb-0",
  style: {"font-size":"0.9rem"}
}
const _hoisted_4 = {
  key: 4,
  class: "text-center text-muted py-5"
}
const _hoisted_5 = {
  class: "d-flex justify-content-between mx-5 align-items-end",
  style: {"font-size":"0.8rem"}
}
const _hoisted_6 = { class: "flex flex-column justify-content-end align-items-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "text-center my-2 fst-italic",
  style: {"font-size":"0.8rem"}
}, " Ngày ..... tháng ..... năm ..... ", -1))

import { computed, PropType } from "vue";
import {
  getPdfPrintContentStyle,
  PDF_BAO_CAO_MARGINS,
} from "@/components/shared/pdf-viewer/pdf-content.config";
import PdfDocumentHeader from "@/components/shared/pdf-viewer/PdfDocumentHeader.vue";
import {
  THU_HOI_VTPT_SHEET_TITLES,
  type ThuHoiVtptSheet,
} from "@/core/helpers/bao-cao-pdf-params";
import { useAuthPdfDonVi } from "@/core/hooks/use-auth-pdf-don-vi";
import DivCol from "@/layout/_shared/DivCol.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import SignatureCol from "@/layout/_shared/SignatureCol.vue";
import type {
  ThuHoiVtptDetail,
  ThuHoiVtptSummary,
} from "@/types/thu-hoi-vtpt";
import ThuHoiB01aTable from "../table-components/ThuHoiB01aTable.vue";
import ThuHoiB01bTable from "../table-components/ThuHoiB01bTable.vue";
import ThuHoiB02aTable from "../table-components/ThuHoiB02aTable.vue";
import ThuHoiB02bTable from "../table-components/ThuHoiB02bTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiVtptThuHoiPrintTemplate',
  props: {
  tenDonVi: { type: String, default: "" },
  tenDonViCha: { type: String, default: "" },
  sheet: {
    type: String as PropType<ThuHoiVtptSheet>,
    required: true,
  },
  summary: {
    type: Object as PropType<ThuHoiVtptSummary | null>,
    default: null,
  },
  detail: {
    type: Object as PropType<ThuHoiVtptDetail | null>,
    default: null,
  },
  fromMonth: { type: Number, default: null },
  toMonth: { type: Number, default: null },
  year: { type: [String, Number], default: "" },
  tenKho: { type: String, default: "" },
},
  setup(__props) {

const paperStyle = getPdfPrintContentStyle({
  orientation: "landscape",
  margins: PDF_BAO_CAO_MARGINS,
});

const props = __props;

const authDonVi = useAuthPdfDonVi();
const resolvedTenDonVi = computed(
  () => props.tenDonVi || authDonVi.tenDonVi.value
);
const resolvedTenDonViCha = computed(
  () => props.tenDonViCha || authDonVi.tenDonViCha.value
);

const title = computed(
  () => THU_HOI_VTPT_SHEET_TITLES[props.sheet] ?? "Theo dõi VTPT thu hồi"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "printing-paper",
    style: _normalizeStyle(_unref(paperStyle))
  }, [
    _createVNode(PdfDocumentHeader, {
      "ten-don-vi": resolvedTenDonVi.value,
      "ten-don-vi-cha": resolvedTenDonViCha.value
    }, null, 8, ["ten-don-vi", "ten-don-vi-cha"]),
    _createVNode(DivRow, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 3 }),
        _createVNode(DivCol, { cols: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, _toDisplayString(title.value), 1),
            _createElementVNode("p", _hoisted_2, " Từ tháng " + _toDisplayString(__props.fromMonth) + " năm " + _toDisplayString(__props.year) + " đến tháng " + _toDisplayString(__props.toMonth) + " năm " + _toDisplayString(__props.year), 1),
            (__props.tenKho)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Kho: " + _toDisplayString(__props.tenKho), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(DivCol, { cols: 3 })
      ]),
      _: 1
    }),
    _createVNode(DivRow, { class: "row mt-2" }, {
      default: _withCtx(() => [
        _createVNode(DivCol, { cols: 12 }, {
          default: _withCtx(() => [
            (__props.sheet === 'b01_b' && __props.summary)
              ? (_openBlock(), _createBlock(ThuHoiB01bTable, {
                  key: 0,
                  "is-print-modal": true,
                  rows: __props.summary.b01_b.rows,
                  totals: __props.summary.b01_b.totals,
                  selectable: false
                }, null, 8, ["rows", "totals"]))
              : (__props.sheet === 'b02_b' && __props.summary)
                ? (_openBlock(), _createBlock(ThuHoiB02bTable, {
                    key: 1,
                    "is-print-modal": true,
                    rows: __props.summary.b02_b.rows,
                    totals: __props.summary.b02_b.totals
                  }, null, 8, ["rows", "totals"]))
                : (__props.sheet === 'b01_a' && __props.detail)
                  ? (_openBlock(), _createBlock(ThuHoiB01aTable, {
                      key: 2,
                      "is-print-modal": true,
                      blocks: __props.detail.b01_a
                    }, null, 8, ["blocks"]))
                  : (__props.sheet === 'b02_a' && __props.detail)
                    ? (_openBlock(), _createBlock(ThuHoiB02aTable, {
                        key: 3,
                        "is-print-modal": true,
                        blocks: __props.detail.b02_a
                      }, null, 8, ["blocks"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "Không có dữ liệu"))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Thủ kho" })
      ]),
      _createElementVNode("div", null, [
        _createVNode(SignatureCol, { "nguoi-ky": "Người giữ sổ" })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(SignatureCol, { "nguoi-ky": "TP Tài Chính" })
      ])
    ])
  ], 4))
}
}

})